module.exports = __webpack_public_path__ + "img/24.1bb6201a.webp";